// // import React, { useState, useContext } from "react";
// // import { useDispatch } from "react-redux";
// // import { ItemContext } from "../../../Context/ItemContext";
// // import styles from "./units.module.css";
// // import PropTypes from "prop-types";
// // import { makeStyles, useTheme } from "@material-ui/core/styles";
// // import TextField from "@material-ui/core/TextField";
// // import Table from "@material-ui/core/Table";
// // import TableBody from "@material-ui/core/TableBody";
// // import TableCell from "@material-ui/core/TableCell";
// // import TableHead from "@material-ui/core/TableHead";
// // import TableContainer from "@material-ui/core/TableContainer";
// // import TableFooter from "@material-ui/core/TableFooter";
// // import TablePagination from "@material-ui/core/TablePagination";
// // import TableRow from "@material-ui/core/TableRow";
// // import Paper from "@material-ui/core/Paper";
// // import IconButton from "@material-ui/core/IconButton";
// // import FirstPageIcon from "@material-ui/icons/FirstPage";
// // import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// // import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// // import LastPageIcon from "@material-ui/icons/LastPage";
// // import Container from "@material-ui/core/Container";
// // import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
// // import BorderColorIcon from "@material-ui/icons/BorderColor";
// // import { Button } from "@material-ui/core";
// // import { useSnackbar } from "react-simple-snackbar";
// // import { useMediaQuery } from "@material-ui/core";
// // import { deleteUnit } from "../../../actions/unitActions";
// // import usePermissions from "../../../utils/permissions";

// // const useStyles1 = makeStyles((theme) => ({
// //   root: {
// //     flexShrink: 0,
// //     marginLeft: theme.spacing(2.5),
// //   },
// // }));

// // function TablePaginationActions(props) {
// //   const classes = useStyles1();
// //   const { count, page, rowsPerPage, onPageChange } = props;

// //   const handleFirstPageButtonClick = (event) => {
// //     onPageChange(event, 0);
// //   };

// //   const handleBackButtonClick = (event) => {
// //     onPageChange(event, page - 1);
// //   };

// //   const handleNextButtonClick = (event) => {
// //     onPageChange(event, page + 1);
// //   };

// //   const handleLastPageButtonClick = (event) => {
// //     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
// //   };

// //   return (
// //     <div className={classes.root}>
// //       <IconButton
// //         onClick={handleFirstPageButtonClick}
// //         disabled={page === 0}
// //         aria-label="first page"
// //       >
// //         <FirstPageIcon />
// //       </IconButton>
// //       <IconButton
// //         onClick={handleBackButtonClick}
// //         disabled={page === 0}
// //         aria-label="previous page"
// //       >
// //         <KeyboardArrowLeft />
// //       </IconButton>
// //       <IconButton
// //         onClick={handleNextButtonClick}
// //         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
// //         aria-label="next page"
// //       >
// //         <KeyboardArrowRight />
// //       </IconButton>
// //       <IconButton
// //         onClick={handleLastPageButtonClick}
// //         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
// //         aria-label="last page"
// //       >
// //         <LastPageIcon />
// //       </IconButton>
// //     </div>
// //   );
// // }

// // TablePaginationActions.propTypes = {
// //   count: PropTypes.number.isRequired,
// //   onPageChange: PropTypes.func.isRequired,
// //   page: PropTypes.number.isRequired,
// //   rowsPerPage: PropTypes.number.isRequired,
// // };

// // const useStyles2 = makeStyles((theme) => ({
// //   table: {
// //     minWidth: 500,
// //   },

// //   tablecell: {
// //     fontSize: "16px",
// //   },
// // }));

// // const Units = ({ setOpen, units }) => {
// //   const classes = useStyles2();
// //   const [page, setPage] = useState(0);
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
// //   const { unitId, setUnitId } = useContext(ItemContext);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [rowsPerPage, setRowsPerPage] = useState(25); // Set default rows per page

// //   const {
// //     loading: permissionsLoading,
// //     canUpdatePage,
// //     canDeletePage,
// //     isAdmin,
// //     canCreatePage,
// //   } = usePermissions();

// //   // eslint-disable-next-line
// //   const [openSnackbar, closeSnackbar] = useSnackbar();
// //   const dispatch = useDispatch();
// //   const rows = units;
// //   // const filteredRows = units.filter((row) =>
// //   //   row.itemName.toLowerCase().includes(searchQuery.toLowerCase())
// //   // );
// //   const filteredRows = rows.filter((row) => {
// //     const searchWords = searchQuery.toLowerCase().split(" ").filter(Boolean); // Split the search query into words
// //     const combinedWord = row.itemName + (row.weight ? row.weight : "");
// //     return searchWords.every((word) =>
// //       combinedWord.toLowerCase().includes(word)
// //     );
// //   });
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };

// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   const handleEdit = (selectedInvoice) => {
// //     //(selectedInvoice);
// //     setOpen((prevState) => !prevState);
// //     setUnitId(selectedInvoice);
// //   };
// //   const handleDelete = (id) => {
// //     const confirmDelete = window.confirm(
// //       "Are you sure you want to delete this unit?"
// //     );
// //     if (confirmDelete) {
// //       dispatch(deleteUnit(id, openSnackbar));
// //     }
// //   };
// //   const tableStyle = {
// //     width: 160,
// //     fontSize: 14,
// //     cursor: "pointer",
// //     borderBottom: "none",
// //     padding: "8px",
// //     textAlign: "center",
// //   };
// //   const headerStyle = { borderBottom: "none", textAlign: "center" };

// //   return (
// //     <div className={styles.pageLayout}>
// //       <Container style={{ width: isMobile ? "100%" : "85%" }}>
// //         <TextField
// //           id="search-bar"
// //           label="Search"
// //           variant="outlined"
// //           margin="normal"
// //           value={searchQuery}
// //           onChange={(e) => setSearchQuery(e.target.value)}
// //         />
// //         <TableContainer component={Paper} elevation={0}>
// //           <Table className={classes.table} aria-label="custom pagination table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell style={{ ...headerStyle, width: "10px" }}>
// //                   Number
// //                 </TableCell>
// //                 <TableCell style={headerStyle}>Name</TableCell>
// //                 <TableCell style={headerStyle}>Abbreviation</TableCell>
// //                 <TableCell style={headerStyle}>Conversion Factor</TableCell>
// //                 <TableCell style={headerStyle}>Edit</TableCell>
// //                 <TableCell style={headerStyle}>Delete</TableCell>
// //               </TableRow>
// //             </TableHead>

// //             <TableBody>
// //               {(rowsPerPage > 0
// //                 ? filteredRows?.slice(
// //                     page * rowsPerPage,
// //                     page * rowsPerPage + rowsPerPage
// //                   )
// //                 : filteredRows
// //               ).map((row, index) => (
// //                 <TableRow key={row._id} styel={{ cursor: "pointer" }}>
// //                   <TableCell style={{ ...tableStyle, width: "10px" }}>
// //                     {index + 1}
// //                   </TableCell>
// //                   <TableCell style={tableStyle} scope="row">
// //                     <Button style={{ textTransform: "none" }}>
// //                       {row.name}
// //                     </Button>
// //                   </TableCell>
// //                   {/* <TableCell style={tableStyle}>{row.unitPrice && row.unitPrice
// //                       ? `₹${row.unitPrice
// //                           .toString()
// //                           .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
// //                       : "N/A"}</TableCell> */}
// //                   <TableCell style={tableStyle}>{row.abbreviation}</TableCell>
// //                   <TableCell style={tableStyle}>
// //                     {row.conversionFactor}
// //                   </TableCell>
// //                   <TableCell style={{ ...tableStyle, width: "10px" }}>
// //                     <IconButton
// //                       disabled={
// //                         permissionsLoading ||
// //                         (!isAdmin() && !canUpdatePage("Units"))
// //                       }
// //                       onClick={() => handleEdit(row._id)}
// //                       style={{
// //                         cursor:
// //                           permissionsLoading ||
// //                           (!isAdmin() && !canUpdatePage("Units"))
// //                             ? "not-allowed"
// //                             : "pointer",
// //                       }}
// //                     >
// //                       <BorderColorIcon
// //                         style={{ width: "20px", height: "20px" }}
// //                       />
// //                     </IconButton>

// //                     {/* <IconButton onClick={() => handleEdit(row._id)}>
// //                       <BorderColorIcon
// //                         style={{ width: "20px", height: "20px" }}
// //                       />
// //                     </IconButton> */}
// //                   </TableCell>
// //                   <TableCell style={{ ...tableStyle, width: "10px" }}>
// //                     <IconButton
// //                       disabled={
// //                         permissionsLoading ||
// //                         (!isAdmin() && !canDeletePage("Units"))
// //                       }
// //                       onClick={() => handleDelete(row._id)}
// //                       style={{
// //                         cursor:
// //                           permissionsLoading ||
// //                           (!isAdmin() && !canDeletePage("Units"))
// //                             ? "not-allowed"
// //                             : "pointer",
// //                       }}
// //                     >
// //                       <DeleteOutlineRoundedIcon
// //                         style={{ width: "20px", height: "20px" }}
// //                       />
// //                     </IconButton>
// //                   </TableCell>
// //                 </TableRow>
// //               ))}
// //             </TableBody>
// //             <TableFooter>
// //               <TableRow>
// //                 <TablePagination
// //                   rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
// //                   colSpan={6}
// //                   count={filteredRows.length} // Update count to the number of filtered rows
// //                   rowsPerPage={rowsPerPage}
// //                   page={page}
// //                   SelectProps={{
// //                     inputProps: { "aria-label": "rows per page" },
// //                     native: true,
// //                   }}
// //                   onPageChange={handleChangePage}
// //                   onRowsPerPageChange={handleChangeRowsPerPage}
// //                   ActionsComponent={TablePaginationActions}
// //                 />
// //               </TableRow>
// //             </TableFooter>
// //           </Table>
// //         </TableContainer>
// //       </Container>
// //     </div>
// //   );
// // };

// // export default Units;

// import React, { useState } from "react";
// import usePermissions from "../../../utils/permissions";
// import { useDispatch } from "react-redux";
// import { deleteBasicUnit, deleteUnit } from "../../../actions/unitActions";
// import { makeStyles } from "@material-ui/core/styles";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
// import TableContainer from "@material-ui/core/TableContainer";
// import TableFooter from "@material-ui/core/TableFooter";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableRow from "@material-ui/core/TableRow";
// import Paper from "@material-ui/core/Paper";
// import IconButton from "@material-ui/core/IconButton";
// import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
// import { useSnackbar } from "react-simple-snackbar";
// import TextField from "@material-ui/core/TextField";

// const useStyles = makeStyles((theme) => ({
//   table: { minWidth: 500 },
//   tablecell: { fontSize: "16px" },
// }));

// const Units = ({ units }) => {
//   const classes = useStyles();
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(25);
//   const [searchQuery, setSearchQuery] = useState("");
//   const dispatch = useDispatch();
//   const [openSnackbar] = useSnackbar();

//   // Filter units where isBasic is true, then apply search
//   const basicUnits = units.filter((unit) => unit.isBasic === true);
//   const filteredRows = basicUnits.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const {
//     loading: permissionsLoading,
//     canUpdatePage,
//     canDeletePage,
//     isAdmin,
//     canCreatePage,
//   } = usePermissions();

//   // const handleDelete = (id) => {
//   //   if (window.confirm("Are you sure you want to delete this unit?")) {
//   //     dispatch(deleteUnit(id, openSnackbar));
//   //   }
//   // };
//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this basic unit?")) {
//       dispatch(deleteBasicUnit(id, openSnackbar));
//     }
//   };

//   const tableStyle = {
//     width: 160,
//     fontSize: 14,
//     borderBottom: "none",
//     padding: "8px",
//     textAlign: "center",
//   };
//   const headerStyle = { borderBottom: "none", textAlign: "center" };

//   return (
//     <div>
//       <TextField
//         label="Search Units"
//         variant="outlined"
//         margin="normal"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//       />
//       <TableContainer component={Paper} elevation={0}>
//         <Table className={classes.table}>
//           <TableHead>
//             <TableRow>
//               {/* <TableCell style={headerStyle}>ID</TableCell> */}
//               <TableCell style={headerStyle}>Unit Name</TableCell>
//               <TableCell style={headerStyle}>Unit Code</TableCell>
//               <TableCell style={headerStyle}>Delete</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {(rowsPerPage > 0
//               ? filteredRows.slice(
//                   page * rowsPerPage,
//                   page * rowsPerPage + rowsPerPage
//                 )
//               : filteredRows
//             ).map((row, index) => (
//               <TableRow key={row._id}>
//                 {/* <TableCell style={tableStyle}>{index + 1}</TableCell> */}
//                 <TableCell style={tableStyle}>{row.name}</TableCell>
//                 <TableCell style={tableStyle}>{row.abbreviation}</TableCell>

//                 {/* <TableCell style={tableStyle}>
//                   <IconButton onClick={() => handleDelete(row._id)}>
//                     <DeleteOutlineRoundedIcon style={{ width: "20px", height: "20px" }} />
//                   </IconButton>
//                 </TableCell> */}

//                 <TableCell style={{ ...tableStyle, width: "10px" }}>
//                   <IconButton
//                     disabled={
//                       permissionsLoading ||
//                       (!isAdmin() && !canDeletePage("Units"))
//                     }
//                     onClick={() => handleDelete(row._id)}
//                     style={{
//                       cursor:
//                         permissionsLoading ||
//                         (!isAdmin() && !canDeletePage("Units"))
//                           ? "not-allowed"
//                           : "pointer",
//                     }}
//                   >
//                     <DeleteOutlineRoundedIcon
//                       style={{ width: "20px", height: "20px" }}
//                     />
//                   </IconButton>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//           <TableFooter>
//             <TableRow>
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
//                 colSpan={4}
//                 count={filteredRows.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
//             </TableRow>
//           </TableFooter>
//         </Table>
//       </TableContainer>
//     </div>
//   );
// };

// export default Units;


// import React, { useState } from "react";
// import usePermissions from "../../../utils/permissions";
// import { useDispatch } from "react-redux";
// import { deleteBasicUnit, deleteUnit } from "../../../actions/unitActions";
// import { makeStyles } from "@material-ui/core/styles";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
// import TableContainer from "@material-ui/core/TableContainer";
// import TableFooter from "@material-ui/core/TableFooter";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableRow from "@material-ui/core/TableRow";
// import Paper from "@material-ui/core/Paper";
// import IconButton from "@material-ui/core/IconButton";
// import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
// import { useSnackbar } from "react-simple-snackbar";
// import TextField from "@material-ui/core/TextField";

// const useStyles = makeStyles((theme) => ({
//   table: { minWidth: 500 },
//   tablecell: { fontSize: "16px" },
// }));

// const Units = ({ units }) => {
//   const classes = useStyles();
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(25);
//   const [searchQuery, setSearchQuery] = useState("");
//   const dispatch = useDispatch();
//   const [openSnackbar] = useSnackbar();

//   // Filter units by search query only (no isBasic filter)
//   const filteredRows = units.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const { loading: permissionsLoading, canDeletePage, isAdmin } = usePermissions();

//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this unit?")) {
//       dispatch(deleteUnit(id, openSnackbar));
//     }
//   };

//   const tableStyle = {
//     width: 160,
//     fontSize: 14,
//     borderBottom: "none",
//     padding: "8px",
//     textAlign: "center",
//   };
//   const headerStyle = { borderBottom: "none", textAlign: "center" };

//   return (
//     <div>
//       <TextField
//         label="Search Units"
//         variant="outlined"
//         margin="normal"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//       />
//       <TableContainer component={Paper} elevation={0}>
//         <Table className={classes.table}>
//           <TableHead>
//             <TableRow>
//               <TableCell style={headerStyle}>Unit Name</TableCell>
//               <TableCell style={headerStyle}>Unit Code</TableCell>
//               <TableCell style={headerStyle}>Delete</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {(rowsPerPage > 0
//               ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               : filteredRows
//             ).map((row) => (
//               <TableRow key={row._id}>
//                 <TableCell style={tableStyle}>{row.name}</TableCell>
//                 <TableCell style={tableStyle}>{row.abbreviation}</TableCell>
//                 <TableCell style={{ ...tableStyle, width: "10px" }}>
//                   <IconButton
//                     disabled={permissionsLoading || (!isAdmin() && !canDeletePage("Units"))}
//                     onClick={() => handleDelete(row._id)}
//                     style={{
//                       cursor: permissionsLoading || (!isAdmin() && !canDeletePage("Units")) ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <DeleteOutlineRoundedIcon style={{ width: "20px", height: "20px" }} />
//                   </IconButton>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//           <TableFooter>
//             <TableRow>
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
//                 colSpan={3}
//                 count={filteredRows.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
//             </TableRow>
//           </TableFooter>
//         </Table>
//       </TableContainer>
//     </div>
//   );
// };

// export default Units;

import React, { useState } from "react";
import usePermissions from "../../../utils/permissions";
import { useDispatch } from "react-redux";
import { deleteUnit } from "../../../actions/unitActions";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  TextField,
  InputAdornment,
  Typography,
  Box,
} from "@material-ui/core";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import { useSnackbar } from "react-simple-snackbar";
import NoData from "../../svgIcons/NoData";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    overflowX: "auto",
  },
  table: {
    minWidth: 500,
    [theme.breakpoints.down("xs")]: {
      minWidth: 300,
    },
  },
  tableHeaderCell: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    textAlign: "center",
    padding: theme.spacing(1.5),
    fontSize: "14px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      padding: theme.spacing(1),
    },
  },
  tableCell: {
    fontSize: "14px",
    borderBottom: "none",
    textAlign: "center",
    padding: theme.spacing(1.5),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      padding: theme.spacing(1),
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  searchField: {
    marginBottom: theme.spacing(2),
    width: "100%",
    maxWidth: 400,
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.shape.borderRadius,
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.dark,
    },
  },
  disabledButton: {
    color: `${theme.palette.action.disabled} !important`,
    cursor: "not-allowed !important",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    textAlign: "center",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
  },
  pagination: {
    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
      fontSize: "14px",
    },
  },
}));

const Units = ({ units }) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar();
  const { loading: permissionsLoading, canDeletePage, isAdmin } = usePermissions();

  // Filter units by search query
  const filteredRows = units.filter((row) =>
    row.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this unit?")) {
      dispatch(deleteUnit(id, openSnackbar));
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setPage(0);
  };

  return (
    <div>
      <TextField
        label="Search Units"
        variant="outlined"
        placeholder="Enter unit name..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={classes.searchField}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton onClick={handleClearSearch} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        aria-label="Search units by name"
      />

      {filteredRows.length === 0 ? (
        <Box className={classes.emptyState}>
          <NoData style={{ width: 120, height: 120 }} />
          <Typography variant="body1" color="textSecondary">
            {searchQuery ? "No units match your search." : "No units available."}
          </Typography>
        </Box>
      ) : (
        <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
          <Table className={classes.table} aria-label="Units table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeaderCell}>Unit Name</TableCell>
                <TableCell className={classes.tableHeaderCell}>Unit Code</TableCell>
                <TableCell className={classes.tableHeaderCell}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredRows
              ).map((row) => (
                <TableRow key={row._id} className={classes.tableRow}>
                  <TableCell className={classes.tableCell}>{row.name}</TableCell>
                  <TableCell className={classes.tableCell}>{row.abbreviation}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <IconButton
                      onClick={() => handleDelete(row._id)}
                      disabled={permissionsLoading || (!isAdmin() && !canDeletePage("Units"))}
                      className={
                        permissionsLoading || (!isAdmin() && !canDeletePage("Units"))
                          ? classes.disabledButton
                          : classes.deleteButton
                      }
                      aria-label={`Delete unit ${row.name}`}
                    >
                      <DeleteOutlineRoundedIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={3}
                  count={filteredRows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  className={classes.pagination}
                  labelRowsPerPage="Rows:"
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default Units;